/* 

Contact Page

*/

import GroupBookings from './GroupBookings.jsx';

export default GroupBookings;